import { DOWNLOAD_FILENAME_MAX_LENGTH } from '@utils'

export type MicroFeTemplate = 'bodenplatte' | 'wu-bodenplatte' | 'kellerdecke'

const MICROFE_EXTENSION = '.mbpma'

const templateFilename: Record<MicroFeTemplate, string> = {
  bodenplatte: 'Bodenplatte',
  'wu-bodenplatte': 'Bodenplatte-Wu',
  kellerdecke: 'Kellerdecke',
}

export const microfeDownloadFilename = ({
  projectName,
  template,
  includeWind,
  includeEarthquake,
}: {
  projectName: string
  template: MicroFeTemplate
  includeWind: boolean
  includeEarthquake: boolean
}): string => {
  const wind = includeWind ? 'WL' : 'keineWL'
  const earthquake = includeEarthquake ? 'EB' : 'keineWB'
  const prefix = 'Fundamentlasten-MicroFE-'
  const suffix = `-${templateFilename[template]}-${wind}-${earthquake}`
  const maxProjectLength =
    DOWNLOAD_FILENAME_MAX_LENGTH - MICROFE_EXTENSION.length - prefix.length - suffix.length
  const safeProjectName = projectName.slice(0, Math.max(0, maxProjectLength))
  return `${prefix}${safeProjectName}${suffix}`
}
